export default __webpack_public_path__ + "static/media/LogoSubtextLight.2d028a53.svg";